// @flow
export const stats = (state: StoreType): any => state.pit.stats;
